// src/pages/SearchPage.jsx
import { useEffect, useState } from "react";
import {useApiClient} from "../apiClient";
import {Link} from "react-router-dom";

export default function SearchPage() {
    const {authorizedFetch} = useApiClient();
    const [query, setQuery] = useState("");
    const [books, setBooks] = useState([]);
    const [status, setStatus] = useState({loading: false, error: ""});

    const handleSearch = async (e) => {
        e?.preventDefault();
        setStatus({loading: true, error: ""});

        try {
            const data = await authorizedFetch(
                `/books/search?query=${encodeURIComponent(query)}`
            );
            setBooks(data);
        } catch (err) {
            setStatus({
                loading: false,
                error: err.message || "Failed to fetch books",
            });
            return;
        }

        setStatus({loading: false, error: ""});
    };

    useEffect(() => {
        // Optionally load all books initially
        handleSearch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <section className="page">
            <h1>Search eBooks</h1>
            <p className="page-subtitle">
                Find books by title, author, or keywords.
            </p>

            <form className="search-bar" onSubmit={handleSearch}>
                <input
                    type="search"
                    placeholder="Search by title, author, or keyword..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <button className="btn btn-primary" disabled={status.loading}>
                    {status.loading ? "Searching..." : "Search"}
                </button>
            </form>

            {status.error && <div className="alert alert-error">{status.error}</div>}

            <div className="book-list">
                {books.length === 0 && !status.loading && (
                    <p className="muted">No books found.</p>
                )}

                {books.map((book) => (
                    <article key={book.id} className="book-card">
                        <h2 className="book-title">{book.title}</h2>
                        <div className="book-author">
                            <strong>Format:</strong> {book.format}
                        </div>
                        <div className="book-description">{book.publisher}</div>
                        <div className="book-actions">
                            <Link to={`/books/${book.id}`} className="btn btn-secondary">
                                View Details
                            </Link>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}